module.exports = __webpack_public_path__ + "img/userlinks_hashnode.com.32f93f88.svg";